export default class PromoImportBtn extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    events() {
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.HegydCore.initRemoteModal(
                '#modal',
                this.href,
                null,
                (data) => {
                    if(data.hasOwnProperty('errors')){
                        if(data.errors.length > 0){
                            toastr.error(data.errors);
                        }else{
                            toastr.success('Fichier importé !');
                        }
                    }

                    window.AppDatatable.table.ajax.reload();
                },
                () => {
                     toastr.error('Une erreur s\'est produite');
                }
            );
        });
    }
}
